export class ApiError extends Error {
    constructor(message: string, public status?: number, public details?: any) {
        super(message);
        this.name = "ApiError";
    }
}

export class NetworkError extends Error {
    constructor(message: string = "Erreur réseau. Vérifiez votre connexion et réessayez.") {
        super(message);
        this.name = "NetworkError";
    }
}

// Spécifique pour les erreurs de validation de formulaire du backend
export class ValidationError extends ApiError {
    constructor(
        message: string,
        public fieldErrors?: Record<string, string[]>, //
        status?: number,
        details?: any
    ) {
        super(message, status, details);
        this.name = "ValidationError";
    }
}

